import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";

const Logout = () => {
    const navigate = useNavigate();
    const auth = getAuth();

    useEffect(() => {
        signOut(auth)
            .then(() => {
                console.log("User signed out");
                navigate("/"); // Redirect to login page after logout
            })
            .catch((error) => {
                console.error("Logout failed:", error);
            });
    }, [auth, navigate]);

    return (
      <div className="page-container" style={{ 
        textAlign: 'center', 
        color: 'var(--text-primary)', 
        fontFamily: 'var(--font-body)',
        fontSize: 'clamp(0.95rem, 2.5vw, 1.1rem)'
      }}>
        <p>Logging out...</p>
      </div>
    );
};

export default Logout;
